import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const pieChartTool: Tool = {
  id: "pie-chart",
  name: () => m.pie_tool_name(),
  description: () => m.pie_tool_description(),
  icon: "🥧",
  basePath: "/pie-chart",
  status: "stable",
  tags: ["chart", "plot", "data-visualization", "pie-chart", "science"],
};
